import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.css'],
  template: `<div style="color:;font-size: 27px; text-align:center; ">
  <b>{{today | date:'fullDate'}}</b>
  <br>
  <b>{{today | date:'h:mm a '}}</b>
</div>` 
})
export class DataListComponent implements OnInit {

  @Input() hero:any;
  
  constructor() { }

  ngOnInit() {
  }

  today: number = Date.now();

}


